module.exports = __webpack_public_path__ + "static/media/spanish.69bf7c3d.png";